import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

export const usePdpSiderailSellerReviewCombinedVariant = (): boolean => {
    const { isPdpSiderailSellerReviewCombinedVariant } = useServerVarsContext();
    return !!isPdpSiderailSellerReviewCombinedVariant;
};
